<template>
  <div id="app" class="app">
		<transition name="router-anim">
    		<router-view/>
		</transition>
  </div>
</template>

<script>

import Vue from "vue";
import { globalStore } from '@/services/userService';

export default {
		name: 'app',
		data() {
			return {
			}
		},
		created: function() {
		},
		methods : {
			launchToast (message, icon, uuid) {
				this.showToast(
					message,
					{
						icon: icon,
						position: 'top-right',
						duration: 5001,
						fullWidth: false,
						action : [
								{
									text : 'Ok',
									onClick : (e, toastObject) => {
										toastObject.goAway(0);
									}
								},
								{
									text : 'Ver',
									onClick : (e, toastObject) => {
										toastObject.goAway(0);
										this.$router.push({ name: 'reports-detail', params: { uuid: uuid }})
									}
								}
							]
					}
				)
			},
			launchErrorToast (message, icon) {

				this.showToast(
					message,
					{
						icon: icon,
						position: 'top-right',
						duration: 5000,
						fullWidth: false,
						action : [
								{
									text : 'Ok',
									onClick : (e, toastObject) => {
										toastObject.goAway(0);
									}
								}
							]
					}
				)
			},
		},
		mounted() {
			let loader;
			let locale = !!globalStore.getLanguage() ? globalStore.getLanguage() : Vue.i18n.locale();

			this.$root.$on("show-loading", (data) => {
				loader = this.$loading.show();
			});

			this.$root.$on("hide-loading", (data) => {
				loader.hide();
			});

      Vue.i18n.set(locale)

		}
  }
</script>

<style lang="scss">
  @import "sass/main";

  body {
    height: 100%;
    #app {
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue